export default __webpack_public_path__ + "static/media/ComfortDelgro-img05.252312c7.png";